// src/components/breadcrumbs.tsx
import { theme } from "@lb-lib/ui";
import { RiArrowRightSLine } from "@remixicon/react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var Wrapper = styled("nav").withConfig({
  componentId: "sc-ltijw8-0"
})`overflow-x:auto;white-space:nowrap;margin-left:-5px;&::-webkit-scrollbar{display:none;}scrollbar-width:none;`;
var BreadcrumbList = styled("ul").withConfig({
  componentId: "sc-ltijw8-1"
})`display:flex;gap:5px;list-style:none;padding:0;margin:0;`;
var BreadcrumbItem = styled("li").withConfig({
  componentId: "sc-ltijw8-2"
})`font-size:14px;color:${theme.colors.gray600};display:flex;align-items:center;gap:5px;`;
var BreadcrumbLink = styled(Link).withConfig({
  componentId: "sc-ltijw8-3"
})`color:${theme.colors.gray600};text-decoration:none;transition:all 0.2s;font-weight:500;font-size:12px;padding:3px 5px;border-radius:4px;&:hover,&:focus{color:${theme.colors.gray800};background:${theme.colors.gray300};}`;
var BreadcrumbSeparator = styled("span").withConfig({
  componentId: "sc-ltijw8-4"
})`color:${theme.colors.gray600};display:flex;svg{height:14px;width:14px;}`;
var Breadcrumbs = ({
  breadcrumbs
}) => {
  return /* @__PURE__ */ jsx(Wrapper, { children: /* @__PURE__ */ jsx(BreadcrumbList, { children: breadcrumbs.map(({
    label,
    to
  }, index) => /* @__PURE__ */ jsxs(BreadcrumbItem, { children: [
    /* @__PURE__ */ jsx(BreadcrumbLink, { to, children: label }),
    index < breadcrumbs.length - 1 && /* @__PURE__ */ jsx(BreadcrumbSeparator, { children: /* @__PURE__ */ jsx(RiArrowRightSLine, {}) })
  ] }, index)) }) });
};

// src/components/editableText.tsx
import { Spinner, theme as theme2 } from "@lb-lib/ui";
import { RiEdit2Line } from "@remixicon/react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { styled as styled2 } from "styled-components";
import useDelayed from "use-delayed";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Wrapper2 = styled2("div").withConfig({
  componentId: "sc-1fh37r7-0"
})`border:solid transparent 1px;border-radius:6px;cursor:pointer;transition:all 0.3s;margin-left:-10px;margin-right:-10px;display:block;width:calc(100% + 0px);display:flex;flex-direction:column;padding-right:10px;padding:3px;&:focus,&:focus-within{border:solid ${theme2.colors.primary} 1px;box-shadow:${theme2.shadows.small};}`;
var Inner = styled2("div").withConfig({
  componentId: "sc-1fh37r7-1"
})`display:flex;align-items:center;`;
var Input = styled2("input").withConfig({
  componentId: "sc-1fh37r7-2"
})`padding:5px 9px;display:block;flex-grow:1;outline:none;border:none;background:transparent;cursor:pointer;`;
var InnerEditor = ({
  placeholder,
  style,
  fontSize,
  fontWeight,
  state,
  hideEditIcon
}) => {
  let currentState = state();
  let [value, setValue] = useState(() => currentState.value);
  useEffect(() => setValue(currentState.value), [currentState.value]);
  let hasChangedRef = useRef(false);
  hasChangedRef.current = value !== currentState.value;
  let inputRef = useRef(null);
  let loading1 = useDelayed(currentState.isLoading, 300, [true]);
  let loading2 = useDelayed(loading1, 150, [true]);
  return /* @__PURE__ */ jsxs2(Inner, { children: [
    /* @__PURE__ */ jsx2(Input, { ref: inputRef, value, onChange: (e) => {
      setValue(e.target.value);
    }, onBlur: () => {
      if (hasChangedRef.current)
        currentState.onChange(value);
    }, onKeyDown: (e) => {
      if (e.key === "Enter") {
        if (hasChangedRef.current)
          currentState.onChange(value);
        e.target.blur();
      }
    }, disabled: currentState.isLoading, placeholder, style: {
      ...style,
      fontSize,
      fontWeight
    } }),
    !hideEditIcon && /* @__PURE__ */ jsxs2("div", { style: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      paddingRight: 5
    }, onClick: () => {
      if (inputRef.current)
        inputRef.current.focus();
    }, children: [
      /* @__PURE__ */ jsx2(RiEdit2Line, { size: 16, style: {
        color: theme2.colors.gray600,
        opacity: loading2 ? 0 : 1,
        transition: "all 0.3s"
      } }),
      /* @__PURE__ */ jsx2(AnimatePresence, { children: loading1 && /* @__PURE__ */ jsx2(motion.div, { initial: {
        opacity: 0
      }, animate: {
        opacity: 1
      }, exit: {
        opacity: 0
      }, style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, children: /* @__PURE__ */ jsx2(Spinner, { size: 12 }) }) })
    ] })
  ] });
};
var EditableText = (props) => {
  let layers = "layers" in props ? props.layers : [props];
  return /* @__PURE__ */ jsx2(Wrapper2, { children: layers.map((layer, i) => /* @__PURE__ */ jsx2(InnerEditor, { ...layer, hideEditIcon: i > 0 }, i)) });
};

// src/components/emptyState.tsx
import { Button, Spacer, Text, Title, theme as theme3 } from "@lb-lib/ui";
import { motion as motion2 } from "framer-motion";
import styled3 from "styled-components";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var Wrapper3 = styled3("section").withConfig({
  componentId: "sc-1gm1iyx-0"
})`display:flex;justify-content:center;padding:max(25px,5vh) 20px;height:100%;`;
var Inner2 = styled3(motion2.div).withConfig({
  componentId: "sc-1gm1iyx-1"
})`width:100%;max-width:400px;display:flex;flex-direction:column;align-items:center;`;
var Actions = styled3("div").withConfig({
  componentId: "sc-1gm1iyx-2"
})`display:flex;gap:15px;flex-wrap:wrap;justify-content:center;align-items:center;`;
var IconWrapper = styled3("figure").withConfig({
  componentId: "sc-1gm1iyx-3"
})`display:flex;align-items:center;justify-content:center;border:solid ${theme3.colors.gray400} 1px;color:${theme3.colors.primary};height:40px;width:40px;box-shadow:${theme3.shadows.small};border-radius:50%;& > svg,& > img{width:50% !important;height:50% !important;color:inherit;}`;
var EmptyState = ({
  icon,
  title,
  description,
  actions
}) => {
  return /* @__PURE__ */ jsx3(Wrapper3, { children: /* @__PURE__ */ jsxs3(Inner2, { initial: {
    opacity: 0,
    scale: 0.95,
    filter: "blur(2px)"
  }, animate: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)"
  }, transition: {
    duration: 0.25,
    ease: "easeOut",
    delay: 0.1
  }, children: [
    /* @__PURE__ */ jsx3(IconWrapper, { children: icon }),
    /* @__PURE__ */ jsx3(Spacer, { height: 20 }),
    /* @__PURE__ */ jsx3(Title, { as: "h1", size: "6", weight: "strong", balance: true, align: "center", children: title }),
    /* @__PURE__ */ jsx3(Spacer, { height: 15 }),
    /* @__PURE__ */ jsx3(Text, { size: "2", weight: "medium", color: "gray600", align: "center", balance: true, children: description }),
    /* @__PURE__ */ jsx3(Spacer, { height: 20 }),
    /* @__PURE__ */ jsx3(Actions, { children: actions.map((action, index) => /* @__PURE__ */ jsx3(Button, { ...action }, index)) })
  ] }) });
};

// src/components/machineContext.tsx
import { Datalist, Flex, Text as Text2 } from "@lb-lib/ui";
import { useMachineContext } from "@loopbound-ares/state";

// src/components/renderWithLoader.ts
import { CenteredSpinner, Error } from "@lb-lib/ui";
import React2, { Fragment } from "react";
var renderWithLoader = (loaders, opts = {}) => (children) => {
  let normalizedLoaders = Object.values(loaders).map((loader) => typeof loader == "boolean" ? {
    isLoading: loader,
    error: void 0
  } : loader);
  let isLoading = Object.values(normalizedLoaders).some((loader) => loader.isLoading);
  let error = Object.values(normalizedLoaders).find((loader) => loader.error !== null)?.error;
  if (isLoading) {
    return React2.createElement(Fragment, {
      children: [opts.spaceTop ? React2.createElement("div", {
        style: {
          height: opts.spaceTop
        }
      }) : null, opts.loading ? opts.loading() : React2.createElement(CenteredSpinner), opts.spaceBottom ? React2.createElement("div", {
        style: {
          height: opts.spaceBottom
        }
      }) : null]
    });
  }
  if (error) {
    return opts.error ? opts.error(error) : React2.createElement(Error, {
      children: error.data.message ?? error.message ?? "An error occurred"
    });
  }
  return children(loaders);
};

// src/components/machineContext.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var unknown = /* @__PURE__ */ jsx4(Text2, { size: "1", color: "gray600", children: "Unknown" });
var MachineContext = ({
  machineContextId
}) => {
  let machineContext = useMachineContext(machineContextId);
  return /* @__PURE__ */ jsx4(Fragment2, { children: renderWithLoader({
    machineContext
  })(({
    machineContext: machineContext2
  }) => {
    return /* @__PURE__ */ jsxs4(Flex, { gap: 15, children: [
      /* @__PURE__ */ jsx4(Datalist, { items: [{
        label: "Machine ID",
        value: `${machineContext2.data.id?.slice(0, 20)}...`
      }, {
        label: "IP",
        value: machineContext2.data.ip?.ip ?? unknown
      }, {
        label: "Country",
        value: machineContext2.data.ip?.country ?? unknown
      }, {
        label: "City",
        value: machineContext2.data.ip?.city ?? unknown
      }, {
        label: "Organization",
        value: machineContext2.data.ip?.organization ?? unknown
      }, {
        label: "Browser",
        value: machineContext2.data.userAgent?.browser.name ?? unknown
      }, {
        label: "OS",
        value: machineContext2.data.userAgent?.os.name ?? unknown
      }] }),
      machineContext2.data.map && /* @__PURE__ */ jsx4("iframe", { src: machineContext2.data.map.url, frameBorder: "0", style: {
        borderRadius: 10,
        width: 200,
        height: 200
      } })
    ] });
  }) });
};

// src/components/pageHeader.tsx
import { Text as Text3, Title as Title2 } from "@lb-lib/ui";
import { useMemo } from "react";
import styled4 from "styled-components";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var Wrapper4 = styled4("div").withConfig({
  componentId: "sc-ps8ecd-0"
})`display:flex;justify-content:space-between;flex-wrap:wrap;gap:10px;`;
var Inner3 = styled4("div").withConfig({
  componentId: "sc-ps8ecd-1"
})`display:flex;flex-direction:column;gap:4px;`;
var Actions2 = styled4("div").withConfig({
  componentId: "sc-ps8ecd-2"
})`display:flex;flex-wrap:wrap;gap:10px;`;
var PageHeader = ({
  title,
  description,
  actions,
  breadcrumbs,
  size = "0",
  marginBottom = "20px"
}) => {
  let parsedSize = useMemo(() => parseInt(size), [size]);
  return /* @__PURE__ */ jsxs5(Wrapper4, { style: {
    marginBottom
  }, children: [
    /* @__PURE__ */ jsxs5(Inner3, { children: [
      breadcrumbs && /* @__PURE__ */ jsx5(Breadcrumbs, { breadcrumbs }),
      /* @__PURE__ */ jsx5(Title2, { as: "h2", weight: "bold", size: String(parsedSize + 4), children: title }),
      description && /* @__PURE__ */ jsx5(Text3, { weight: "medium", size: "2", color: "gray600", children: description })
    ] }),
    actions && /* @__PURE__ */ jsx5(Actions2, { children: actions })
  ] });
};

// src/components/productLogo.tsx
import { useShell } from "@loopbound-ares/state";
import styled5 from "styled-components";
import { jsx as jsx6 } from "react/jsx-runtime";
var Wrapper5 = styled5("div").withConfig({
  componentId: "sc-1n9buvr-0"
})`aspect-ratio:1;display:flex;svg{height:40px;width:40px;}img{height:40px;width:40px;object-fit:contain;}`;
var ProductLogo = ({
  size = 40
}) => {
  let shell = useShell();
  return /* @__PURE__ */ jsx6(Wrapper5, { style: {
    width: size,
    height: size
  }, children: shell.logo });
};

// src/components/sidebarItems.tsx
import { Tooltip, theme as theme4 } from "@lb-lib/ui";
import { RiAddLine, RiArrowDownSLine } from "@remixicon/react";
import clsx from "clsx";
import { AnimatePresence as AnimatePresence2, motion as motion3 } from "framer-motion";
import { Fragment as Fragment3, useEffect as useEffect2, useState as useState2 } from "react";
import { Link as Link2, useLocation } from "react-router-dom";
import styled6 from "styled-components";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Wrapper6 = styled6("div").withConfig({
  componentId: "sc-1u06ot9-0"
})`display:flex;flex-direction:column;gap:6px;&:not(:last-of-type){margin-bottom:15px;}`;
var LabelBarButton = styled6("button").withConfig({
  componentId: "sc-1u06ot9-1"
})`margin-left:5px;padding:3px 5px;min-height:22px;border-radius:4px;background:none;cursor:pointer;outline:none;border:none;text-align:left;transition:all 0.2s;width:fit-content;display:flex;gap:5px;align-items:center;color:${theme4.colors.gray700};p{font-size:12px;font-weight:500;transition:all 0.2s;}&.collapsible{&:hover,&:focus{background:${theme4.colors.gray400};color:${theme4.colors.foreground};}}`;
var LabelBar = styled6("div").withConfig({
  componentId: "sc-1u06ot9-2"
})`display:flex;align-items:center;justify-content:space-between;`;
var Items = styled6("div").withConfig({
  componentId: "sc-1u06ot9-3"
})`display:flex;flex-direction:column;gap:3px;`;
var Item = styled6("div").withConfig({
  shouldForwardProp: (prop) => !["activeBackground", "activeBar", "activeColor"].includes(prop)
}).withConfig({
  componentId: "sc-1u06ot9-4"
})`height:32px;padding:0px 10px;display:flex;align-items:center;border-radius:7px;cursor:pointer;gap:12px;position:relative;transition:all 0.2s;background:${(p) => p.activeBackground ? String(theme4.colors.gray400) : "none"};color:${(p) => p.activeColor ? String(theme4.colors.foreground) : String(theme4.colors.gray700)};font-weight:${(p) => p.activeColor ? 600 : 450};&:hover,&:focus{background:${theme4.colors.gray400};}&::after{content:'';position:absolute;left:-2px;top:6px;bottom:6px;width:4px;border-radius:7px;transition:all 0.2s;background:${theme4.colors.blue800};opacity:${(p) => p.activeBar ? 1 : 0};transform:${(p) => p.activeBar ? "scaleY(1)" : "scaleY(0)"};}`;
var Icon = styled6("span").withConfig({
  componentId: "sc-1u06ot9-5"
})`display:flex;align-items:center;svg{height:16px;width:16px;}`;
var Text4 = styled6("p").withConfig({
  componentId: "sc-1u06ot9-6"
})`font-size:14px;flex-grow:1;text-align:left;`;
var SidebarGroup = ({
  label,
  collapsible,
  items: _items,
  onCreate,
  isCollapsed,
  setCollapse
}) => {
  let [initial, setInitial] = useState2(true);
  useEffect2(() => {
    let to = setTimeout(() => setInitial(false), 500);
    return () => clearTimeout(to);
  }, []);
  useLocation();
  let items = _items.map(({
    getProps,
    ...item
  }) => {
    let children = item.children?.map((child) => {
      let isActive2 = child.getProps?.({
        pathname: window.location.pathname
      }).isActive;
      return {
        ...child,
        isActive: isActive2
      };
    }) ?? [];
    let childrenActive = children?.some((child) => child.isActive);
    let isActive = getProps?.({
      pathname: window.location.pathname
    }).isActive || childrenActive;
    return {
      ...item,
      isActive,
      children,
      childrenActive
    };
  });
  return /* @__PURE__ */ jsxs6(Wrapper6, { children: [
    label && /* @__PURE__ */ jsxs6(LabelBar, { children: [
      label && /* @__PURE__ */ jsxs6(LabelBarButton, { as: collapsible ? "button" : "div", onClick: () => collapsible && setCollapse?.(!isCollapsed), className: clsx({
        collapsible
      }), children: [
        /* @__PURE__ */ jsx7("p", { children: label }),
        collapsible && /* @__PURE__ */ jsx7(RiArrowDownSLine, { size: 14, style: {
          transform: isCollapsed ? "rotate(0deg)" : "rotate(180deg)",
          transition: "transform 0.2s"
        } })
      ] }),
      onCreate && /* @__PURE__ */ jsx7(Tooltip, { content: "Create new", side: "right", children: /* @__PURE__ */ jsx7(LabelBarButton, { onClick: onCreate, style: {
        justifyContent: "center",
        padding: 0,
        width: 22
      }, className: "collapsible", children: /* @__PURE__ */ jsx7(RiAddLine, { size: 14 }) }) })
    ] }),
    /* @__PURE__ */ jsx7(AnimatePresence2, { children: !isCollapsed && /* @__PURE__ */ jsx7(motion3.div, { initial: initial ? {
      opacity: 1,
      height: "auto"
    } : {
      opacity: 0,
      height: 0
    }, animate: {
      opacity: 1,
      height: "auto"
    }, exit: {
      opacity: 0,
      height: 0
    }, transition: {
      duration: 0.15
    }, style: {
      overflow: "hidden",
      padding: "0px 2px"
    }, children: /* @__PURE__ */ jsx7(Items, { children: items.map((item, index) => /* @__PURE__ */ jsxs6(Fragment3, { children: [
      item.to ? /* @__PURE__ */ jsx7(Link2, { to: item.to, onClick: item.onClick, children: /* @__PURE__ */ jsxs6(Item, { activeBackground: item.isActive && !item.childrenActive, activeBar: item.isActive && !item.childrenActive, activeColor: item.isActive && !item.childrenActive, children: [
        /* @__PURE__ */ jsx7(Icon, { children: item.icon }),
        /* @__PURE__ */ jsx7(Text4, { children: item.label })
      ] }) }, index) : /* @__PURE__ */ jsx7("button", { onClick: item.onClick, style: {
        background: "none",
        border: "none",
        padding: 0,
        outline: "none"
      }, children: /* @__PURE__ */ jsxs6(Item, { activeBackground: item.isActive && !item.childrenActive, activeBar: item.isActive && !item.childrenActive, activeColor: item.isActive && !item.childrenActive, children: [
        /* @__PURE__ */ jsx7(Icon, { children: item.icon }),
        /* @__PURE__ */ jsx7(Text4, { children: item.label })
      ] }) }, index),
      /* @__PURE__ */ jsx7(AnimatePresence2, { children: item.isActive && item.children.length && /* @__PURE__ */ jsx7(motion3.div, { initial: {
        opacity: 0,
        height: 0,
        x: -10
      }, animate: {
        opacity: 1,
        height: "auto",
        x: 0
      }, exit: {
        opacity: 0,
        height: 0,
        x: 0
      }, style: {
        overflow: "hidden"
      }, children: item.children?.map((child, index2) => /* @__PURE__ */ jsx7(Link2, { to: child.to, children: /* @__PURE__ */ jsx7(Item, { activeBackground: child.isActive, activeBar: child.isActive, activeColor: child.isActive, style: {
        marginLeft: 24
      }, children: /* @__PURE__ */ jsx7(Text4, { children: child.label }) }) }, index2)) }) })
    ] }, index)) }) }) })
  ] });
};
var SidebarItems = ({
  groups
}) => {
  let [collapsibleState, setCollapsibleState] = useState2([]);
  return /* @__PURE__ */ jsx7("div", { children: groups.map((group, index) => /* @__PURE__ */ jsx7(SidebarGroup, { ...group, isCollapsed: collapsibleState.includes(index), setCollapse: (value) => {
    setCollapsibleState((collapsibleState2) => value ? [...collapsibleState2, index] : collapsibleState2.filter((i) => i != index));
  } }, index)) });
};

// src/layouts/centeredLayout.tsx
import styled7 from "styled-components";
import { jsx as jsx8 } from "react/jsx-runtime";
var Wrapper7 = styled7("div").withConfig({
  componentId: "sc-22cigw-0"
})`height:100dvh;display:flex;justify-content:center;align-items:center;flex-direction:column;`;
var Inner4 = styled7("div").withConfig({
  componentId: "sc-22cigw-1"
})`max-width:100%;max-height:calc(100% - 40px);padding:0 20px;display:flex;text-align:center;flex-direction:column;`;
var CenteredLayout = ({
  children,
  width
}) => {
  return /* @__PURE__ */ jsx8(Wrapper7, { children: /* @__PURE__ */ jsx8(Inner4, { style: {
    width: width ?? 400
  }, children }) });
};

// src/layouts/content.tsx
import styled8 from "styled-components";
import { jsx as jsx9 } from "react/jsx-runtime";
var sizes = {
  slim: "600px",
  medium: "800px",
  large: "1000px",
  full: "100%"
};
var Wrapper8 = styled8("div").withConfig({
  shouldForwardProp: (prop) => prop !== "variant"
}).withConfig({
  componentId: "sc-nnxho4-0"
})`max-width:${({
  variant
}) => sizes[variant]};width:calc(100% - 40px);margin:0 auto;padding:20px 0px;`;
var ContentLayout = ({
  children,
  variant
}) => {
  return /* @__PURE__ */ jsx9(Wrapper8, { variant, children });
};

// src/layouts/contentPanel.tsx
import { Title as Title3, theme as theme5 } from "@lb-lib/ui";
import styled9 from "styled-components";
import { jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var Wrapper9 = styled9("div").withConfig({
  componentId: "sc-1nyeknp-0"
})`display:flex;flex-direction:column;position:relative;`;
var Header = styled9("header").withConfig({
  componentId: "sc-1nyeknp-1"
})`border-bottom:1px solid ${theme5.colors.gray300};padding:20px 20px;position:sticky;top:0;display:flex;flex-direction:column;gap:3px;background:${theme5.colors.background};z-index:45;`;
var Content = styled9("main").withConfig({
  componentId: "sc-1nyeknp-2"
})``;
var ContentPanelLayout = ({
  children,
  title,
  breadcrumbs
}) => {
  return /* @__PURE__ */ jsxs7(Wrapper9, { children: [
    /* @__PURE__ */ jsxs7(Header, { children: [
      breadcrumbs && /* @__PURE__ */ jsx10(Breadcrumbs, { breadcrumbs }),
      title && /* @__PURE__ */ jsx10(Title3, { as: "h1", size: "3", weight: "strong", children: title })
    ] }),
    /* @__PURE__ */ jsx10(Content, { children })
  ] });
};

// src/layouts/error.tsx
import { AccordionSingle, Button as Button2, CenteredLoopboundLogo, Spacer as Spacer2, Text as Text5, Title as Title4 } from "@lb-lib/ui";
import styled10 from "styled-components";
import { jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var Pre = styled10("pre").withConfig({
  componentId: "sc-n5zyer-0"
})`background:#f4f4f4;padding:20px;border-radius:4px;text-align:left;overflow:auto;margin:0px;`;
var ErrorLayout = ({
  title,
  description,
  action,
  error
}) => {
  return /* @__PURE__ */ jsxs8(CenteredLayout, { children: [
    /* @__PURE__ */ jsx11(CenteredLoopboundLogo, {}),
    /* @__PURE__ */ jsx11(Spacer2, { height: 20 }),
    /* @__PURE__ */ jsx11(Title4, { as: "h1", size: "6", weight: "medium", align: "center", children: title }),
    /* @__PURE__ */ jsx11(Spacer2, { height: 10 }),
    /* @__PURE__ */ jsx11(Text5, { align: "center", children: description }),
    /* @__PURE__ */ jsx11(Spacer2, { height: 15 }),
    /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Button2, { variant: "solid", onClick: () => {
      if (typeof action.action === "string") {
        window.location.href = action.action;
      } else {
        action.action();
      }
    }, children: action.text }) }),
    /* @__PURE__ */ jsx11(Spacer2, { height: 20 }),
    error && /* @__PURE__ */ jsx11(AccordionSingle, { title: "Error Details", children: /* @__PURE__ */ jsxs8(Pre, { children: [
      error?.message,
      /* @__PURE__ */ jsx11("br", {}),
      /* @__PURE__ */ jsx11("br", {}),
      error?.stack
    ] }) })
  ] });
};

// src/layouts/extraHeaderLayout.tsx
import { theme as theme6 } from "@lb-lib/ui";
import styled11 from "styled-components";
import { jsx as jsx12, jsxs as jsxs9 } from "react/jsx-runtime";
var Wrapper10 = styled11("div").withConfig({
  componentId: "sc-1dcnn02-0"
})`height:100%;display:flex;flex-direction:column;position:relative;`;
var Header2 = styled11("div").withConfig({
  componentId: "sc-1dcnn02-1"
})`padding:15px 20px;border-bottom:1px solid ${theme6.colors.gray300};position:sticky;top:0;background:${theme6.colors.background};z-index:50;`;
var Content2 = styled11("div").withConfig({
  componentId: "sc-1dcnn02-2"
})`display:flex;flex-grow:1;flex-direction:column;overflow:auto;`;
var ExtraHeaderLayout = ({
  children,
  header
}) => {
  return /* @__PURE__ */ jsxs9(Wrapper10, { children: [
    /* @__PURE__ */ jsx12(Header2, { children: header }),
    /* @__PURE__ */ jsx12(Content2, { children })
  ] });
};

// src/layouts/sidebarLayout.tsx
import styled12 from "styled-components";
import { jsx as jsx13, jsxs as jsxs10 } from "react/jsx-runtime";
var Wrapper11 = styled12("div").withConfig({
  componentId: "sc-1q52pjh-0"
})`min-height:100%;display:flex;position:relative;flex-grow:1;`;
var Sidebar = styled12("div").withConfig({
  componentId: "sc-1q52pjh-1"
})`padding:5px 20px 0px 0px;position:relative;width:250px;flex-shrink:0;margin-left:-10px;`;
var Main = styled12("div").withConfig({
  componentId: "sc-1q52pjh-2"
})`max-height:100%;flex-grow:1;display:flex;flex-direction:column;`;
var SidebarLayout = ({
  groups,
  children
}) => {
  return /* @__PURE__ */ jsxs10(Wrapper11, { children: [
    /* @__PURE__ */ jsx13(Sidebar, { children: /* @__PURE__ */ jsx13(SidebarItems, { groups }) }),
    /* @__PURE__ */ jsx13(Main, { children })
  ] });
};

// src/layouts/sidebarPane.tsx
import { theme as theme7 } from "@lb-lib/ui";
import styled13 from "styled-components";
import { jsx as jsx14, jsxs as jsxs11 } from "react/jsx-runtime";
var Wrapper12 = styled13("div").withConfig({
  componentId: "sc-2argb5-0"
})`height:100%;display:flex;position:relative;flex-grow:1;`;
var Sidebar2 = styled13("div").withConfig({
  componentId: "sc-2argb5-1"
})`max-height:100%;overflow-y:auto;overflow-x:hidden;border-right:1px solid ${theme7.colors.gray300};padding:25px 20px;position:relative;width:250px;flex-shrink:0;`;
var Main2 = styled13("div").withConfig({
  componentId: "sc-2argb5-2"
})`max-height:100%;overflow-y:auto;overflow-x:hidden;flex-grow:1;display:flex;flex-direction:column;`;
var SidebarPane = ({
  groups,
  children
}) => {
  return /* @__PURE__ */ jsxs11(Wrapper12, { children: [
    /* @__PURE__ */ jsx14(Sidebar2, { children: /* @__PURE__ */ jsx14(SidebarItems, { groups }) }),
    /* @__PURE__ */ jsx14(Main2, { children })
  ] });
};

// src/pages/error.tsx
import { useRouteError } from "react-router-dom";

// src/pages/notFound.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var NotFoundPage = () => {
  return /* @__PURE__ */ jsx15(ErrorLayout, { title: "Page not found", description: "The page you are looking for does not exist or you do not have permission to access it.", action: {
    text: "Back to Home",
    action: "/"
  } });
};

// src/pages/error.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var ErrorPage = () => {
  let error = useRouteError();
  if (error?.data?.status == 404 || error?.status == 404)
    return /* @__PURE__ */ jsx16(NotFoundPage, {});
  return /* @__PURE__ */ jsx16(ErrorLayout, { title: "An error occurred", description: "Loopbound Form has encountered an error and cannot continue. Please reload the page and try again.", error: error?.error ?? error, action: {
    text: "Reload",
    action: () => {
      window.location.reload();
    }
  } });
};

// src/pages/loadingError.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var LoadingErrorPage = ({
  error
}) => {
  if (error?.data?.status == 404)
    return /* @__PURE__ */ jsx17(NotFoundPage, {});
  return /* @__PURE__ */ jsx17(ErrorLayout, { title: "An error occurred", description: error.data?.message || error.message, error, action: {
    text: "Reload",
    action: () => {
      window.location.reload();
    }
  } });
};
export {
  Breadcrumbs,
  CenteredLayout,
  ContentLayout,
  ContentPanelLayout,
  EditableText,
  EmptyState,
  ErrorLayout,
  ErrorPage,
  ExtraHeaderLayout,
  LoadingErrorPage,
  MachineContext,
  NotFoundPage,
  PageHeader,
  ProductLogo,
  SidebarItems,
  SidebarLayout,
  SidebarPane,
  renderWithLoader
};
//# sourceMappingURL=index.js.map